<nz-spin [nzSpinning]="loading">
  <nz-card>
    <div class="表格">
      <div>
        <strong class="margin-left-8 result">{{ "Results" | translate}}({{nzTotal}})</strong>
      </div>
      <nz-table #colSpanTable [nzData]="listOfData" style="margin-bottom: 10px" nzSize="middle" nzShowSizeChanger
        [nzFrontPagination]="false" [nzShowPagination]='false' [nzPageSize]='pageSize' [nzPageIndex]='pageIndex'>
        <thead>
          <tr>
            <th scope="col" style="text-align:center;">{{ "Site" | translate}}</th>
            <th scope="col" style="text-align:center;">{{ "CNMaintain" | translate}}</th>
            <th scope="col" style="text-align:center;">{{ "TWMaintain" | translate}}</th>
            <th scope="col" style="text-align:center;">{{ "DeliveryMaintain" | translate}}</th>
            <th scope="col" style="text-align:center;">{{ "ContractCooperationManagement" | translate}}</th>
            <th scope="col" style="text-align:center;">{{ "SourcingPricingManagement" | translate}}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of colSpanTable.data;let i=index">
            <td style="text-align:center;">{{data.hrSite}}</td>

            <td style="text-align:center;">
              <div *ngIf="data.chStatementPaymentManagement=='Y' ">
                <nz-switch [ngModel]="true" (click)="onOffchStatement(data)"></nz-switch>
              </div>
              <div *ngIf="data.chStatementPaymentManagement=='N' ">
                <nz-switch [ngModel]="false" (click)="onopenchStatement(data)"></nz-switch>
              </div>
            </td>

            <td style="text-align:center;">
              <div *ngIf="data.twStatementPaymentManagement=='Y' ">
                <nz-switch [ngModel]="true" (click)="onOfftwStatement(data)"></nz-switch>
              </div>
              <div *ngIf="data.twStatementPaymentManagement=='N' ">
                <nz-switch [ngModel]="false" (click)="onopentwStatement(data)"></nz-switch>
              </div>
            </td>

            <td style="text-align:center;">
              <div *ngIf="data.deliveryMaintain=='Y' ">
                <nz-switch [ngModel]="true" (click)="onOffdeliveryMaintain(data)"></nz-switch>
              </div>
              <div *ngIf="data.deliveryMaintain=='N' ">
                <nz-switch [ngModel]="false" (click)="onopendeliveryMaintain(data)"></nz-switch>
              </div>
            </td>

            <td style="text-align:center;">
              <div *ngIf="data.contractCooperationManagement=='Y' ">
                <nz-switch [ngModel]="true" (click)="onOffContractCooperationManagement(data)"></nz-switch>
              </div>
              <div *ngIf="data.contractCooperationManagement=='N' ">
                <nz-switch [ngModel]="false" (click)="onopenContractCooperationManagement(data)"></nz-switch>
              </div>
            </td>

            <td style="text-align:center;">
              <div *ngIf="data.sourcingPricingManagement=='Y' ">
                <nz-switch [ngModel]="true" (click)="onOffSourcingPricingManagement(data)"></nz-switch>
              </div>
              <div *ngIf="data.sourcingPricingManagement=='N' ">
                <nz-switch [ngModel]="false" (click)="onopenSourcingPricingManagement(data)"></nz-switch>
              </div>
            </td>


          </tr>
        </tbody>
      </nz-table>
      <nz-pagination style="float:right;" [(nzPageIndex)]="pageIndex" [nzTotal]="nzTotal" [nzSize]="'small'"
        nzShowSizeChanger [nzPageSizeOptions]="[20]" [nzPageSize]='pageSize'
        (nzPageSizeChange)="nzPageSizeChange($event)" nzShowQuickJumper (nzPageIndexChange)="nzPageIndexChange($event)">
      </nz-pagination>
    </div>
  </nz-card>
</nz-spin>